'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function SidebarBrowseByMerchant({
  routes,
  merchants,
  className = '',
  localisation = {},
  bloodhound,
}) {
  const merchantList = merchants.map(({ merchantSlug, merchantName }) =>
    h('li.sidebar-browse-item', [
      h(
        'a.sidebar-browse-link',
        {
          href: routes.merchant.show.replace('{merchantSlug}', merchantSlug),
          'data-bhc': `store:${merchantSlug}`,
        },
        merchantName
      ),
    ])
  );

  return (
    merchantList.length > 0 &&
    h(
      `.sidebar-browse.${className}`,
      h(
        '.sidebar-browse-inner',
        {
          'data-bhw': bloodhound,
        },
        [
          h(Translate, localisation.data, localisation.resource),
          h('ul.sidebar-browse-list', merchantList),
        ]
      )
    )
  );
}

module.exports = SidebarBrowseByMerchant;
